/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VaultMemberList } from '../../models/vault-member-list';

export interface VaultGetMemberList$Params {

/**
 * GUID of the vault
 */
  vaultId: string;
}

export function vaultGetMemberList(http: HttpClient, rootUrl: string, params: VaultGetMemberList$Params, context?: HttpContext): Observable<StrictHttpResponse<VaultMemberList>> {
  const rb = new RequestBuilder(rootUrl, vaultGetMemberList.PATH, 'get');
  if (params) {
    rb.path('vaultId', params.vaultId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VaultMemberList>;
    })
  );
}

vaultGetMemberList.PATH = '/vault/{vaultId}/member/list';
